import { createContext, Dispatch, SetStateAction } from 'react';

import { FormulaType } from '../constants/formulaType';

import { GenericMessagePreviewModel } from '../models/editor.model';
// models
import {
    FormulaAdditionalMetadata,
    FormulaDetailModel,
} from '../models/formula.model';
import { LabelModel } from '../models/label.model';

export interface EditorDetailsModel {
    formula: FormulaDetailModel | null;
    formulaType: FormulaType | null;
    previews: GenericMessagePreviewModel[];
    testPreviews: GenericMessagePreviewModel[];
    isPreviewError: boolean;
    previewError: string | null;
    isGenerating: boolean;
    isApproved: boolean;
    newly_created_alternate_id: string;
    selectedLabel?: LabelModel;
    isControlledFormula?: boolean;
    isSecondaryView?: boolean;
    additional_metadata?: FormulaAdditionalMetadata;
    showSmallPhone?: boolean;
    selectRandomFilters?: boolean;
    alternateMessagesCount?: number;
}

export interface MessageContentContextModel {
    isContentUpdating: boolean;
    setIsContentUpdating: (value: boolean) => void;
}

export interface EditorContextModel {
    editorDetails: EditorDetailsModel;
    setEditorDetails: Dispatch<SetStateAction<EditorDetailsModel>>;
}

export const defaultEditorDetails: EditorDetailsModel = {
    formula: null,
    formulaType: null,
    previews: [],
    testPreviews: [],
    isPreviewError: false,
    previewError: null,
    isGenerating: false,
    isApproved: false,
    newly_created_alternate_id: '',
    selectedLabel: undefined,
    isControlledFormula: false,
    isSecondaryView: false,
    showSmallPhone: false,
    selectRandomFilters: false,
    alternateMessagesCount: 0,
};

export const EditorContext = createContext<EditorContextModel>({
    editorDetails: defaultEditorDetails,
    setEditorDetails: () => {},
});

export const MessageContentContext = createContext<MessageContentContextModel>({
    isContentUpdating: false,
    setIsContentUpdating: () => {},
});
